<p-toast></p-toast>
<main class="import-page">
  <section class="import-hero">
    <div>
      <a routerLink="/location" class="back-link"><i class="pi pi-arrow-left"></i> Locations</a>
      <h1>Upload Locations</h1>
      <p>Validate an Excel workbook, review each Create or Update action, then apply the batch.</p>
    </div>
    <p-button label="Download template" icon="pi pi-download" severity="secondary" [outlined]="true"
      [loading]="downloading" (click)="downloadTemplate()"></p-button>
  </section>

  <section class="import-card">
    <h2>Choose workbook</h2>
    <p>Use the template or an export from the Locations directory. Existing rows match by Location Code within this company; leave Code blank for a new Location. Location Zone is optional. Enter Latitude and Longitude, or paste a Google Maps link or coordinate pair in the Google Maps URL or Coordinates column. Only the default contact is writable; access contacts and merchandiser counts are informational.</p>
    <div class="upload-actions">
      <input type="file" accept=".xlsx" (change)="selectFile($event)" aria-label="Choose Locations Excel workbook">
      <p-button label="Upload and validate" icon="pi pi-upload" [disabled]="!file || uploading"
        [loading]="uploading" (click)="upload()"></p-button>
    </div>
  </section>

  <section *ngIf="current" class="import-card">
    <div class="section-title">
      <div>
        <h2>Review batch #{{ current.id }}</h2>
        <p>{{ current.fileName }} · {{ current.totalRows }} rows · {{ current.validRows }} ready · {{ current.invalidRows }} issues</p>
      </div>
      <p-button label="Confirm all changes" icon="pi pi-check" [disabled]="!canConfirm"
        [loading]="confirming" (click)="confirm()"></p-button>
    </div>
    <p *ngIf="current.invalidRows" class="issue-note">Correct all issues in the workbook and upload it again before confirming.</p>
    <p-table [value]="current.rows || []" [paginator]="true" [rows]="20"
      [rowsPerPageOptions]="[20, 50, 100]" styleClass="p-datatable-sm p-datatable-gridlines"
      [tableStyle]="{ 'min-width': '64rem' }">
      <ng-template pTemplate="header">
        <tr><th>Excel row</th><th>Action</th><th>Code</th><th>Name</th><th>Country / City</th><th>Issues</th><th>Workbook values</th></tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.rowNumber }}</td>
          <td><p-tag [value]="row.action" [severity]="row.action === 'CREATE' ? 'info' : 'secondary'"></p-tag></td>
          <td>{{ row.values['Code'] || 'Generated on confirm' }}</td>
          <td>{{ row.values['Name'] || '—' }}</td>
          <td>{{ row.values['Country Code'] || row.values['Country'] || '—' }} / {{ row.values['City'] || '—' }}</td>
          <td>
            <span *ngIf="!row.issues.length" class="ready">Ready</span>
            <ul *ngIf="row.issues.length" class="issue-list"><li *ngFor="let issue of row.issues">{{ issue }}</li></ul>
          </td>
          <td><details><summary>View row</summary>
            <dl class="row-values"><ng-container *ngFor="let field of row.values | keyvalue">
              <ng-container *ngIf="field.key !== '_rowNumber' && field.key !== '_locationError' && field.value">
                <dt>{{ field.key }}</dt><dd>{{ field.value }}</dd>
              </ng-container>
            </ng-container></dl>
          </details></td>
        </tr>
      </ng-template>
    </p-table>
  </section>

  <section class="import-card">
    <h2>Import history</h2>
    <p-table [value]="history" [paginator]="true" [rows]="10" styleClass="p-datatable-sm">
      <ng-template pTemplate="header"><tr><th>Batch</th><th>File</th><th>Uploaded</th><th>Rows</th><th>Status</th><th></th></tr></ng-template>
      <ng-template pTemplate="body" let-batch>
        <tr>
          <td>#{{ batch.id }}</td><td>{{ batch.fileName }}</td><td>{{ batch.createdAt | date:'medium' }}</td>
          <td>{{ batch.totalRows }}</td>
          <td><p-tag [value]="batch.status" [severity]="batch.status === 'CONFIRMED' ? 'success' : 'info'"></p-tag></td>
          <td><button type="button" class="review-link" (click)="open(batch)">Review</button></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage"><tr><td colspan="6">No Location imports yet.</td></tr></ng-template>
    </p-table>
  </section>
</main>
